import { Select, SelectOptionProps } from '@innovationnorway/component-library';
import React from 'react';
import { useParams } from 'react-router-dom';
import useTargetNumbers from '../../hooks/useTargetNumbers';
import { PropertyKey, TargetNumberDto } from 'src/api/v2';
import { newValueDto } from '../../hooks/useAchievedGoalsColumns';
import { lowercaseFirstLetter } from './Integer';

type Props = {
  targetNumber: TargetNumberDto;
  propertyKey: PropertyKey;
  editMode: boolean;
  options: SelectOptionProps[];
};

const DropdownEnum = ({ targetNumber, propertyKey, editMode, options }: Props) => {
  const { goalId } = useParams();
  const idArray = goalId?.split('|') || [];
  const { updateMutation } = useTargetNumbers(idArray[0] || '', idArray[1] || '');
  const value = targetNumber.valueDto ? targetNumber.valueDto[lowercaseFirstLetter(propertyKey)] : null;

  const onChange = (level) => {
    if (level === value) return;
    const newDto = { ...newValueDto };
    newDto[lowercaseFirstLetter(propertyKey)] = level;
    updateMutation.mutateAsync([
      {
        ...targetNumber,
        valueDto: newDto,
      },
    ]);
  };

  return editMode ? (
    <Select
      label="SRL Nivå"
      name="SRL Nivå"
      hideLabel
      hideError
      value={value}
      className="margin--0"
      options={options}
      placeholder={'Ikke satt'}
      onChange={onChange}
    />
  ) : (
    <div className="margin-y--1">{options.find((option) => option.value === value)?.text ?? value}</div>
  );
};

export default DropdownEnum;
